import * as React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
const LiveTail = React.memo((props) => (<Icon component={() => (<svg focusable="false" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <g>
          <path d="M11.9 7.25H9.425a.3.3 0 0 1-.3-.3v-4.8a.3.3 0 0 0-.54-.18L3.86 8.27a.3.3 0 0 0 .24.48h2.475a.3.3 0 0 1 .3.3v4.8a.3.3 0 0 0 .54.18l4.725-6.3a.3.3 0 0 0-.24-.48z"/>
        </g>
      </svg>)} {...props}/>));
export default LiveTail;
